import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { hasAnalyticsConsent } from "../utils/cookieConsent";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page view in Matomo for SPA navigation - nur mit Consent
    if (hasAnalyticsConsent() && window._paq) {
      window._paq.push(['setCustomUrl', pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;